export default {
    getList: {
        default: [{
            host: "FTP115",
            method: 4,
            site_id: 10,
            site_name: "玉环市第二人民医院",
            status: 1,
            alert_severity: 6
        }, {
            host: "EMC VNX5600(DX)",
            method: 4,
            site_id: 47,
            site_name: "天台县人力资源和社会保障局",
            status: 0,
            alert_severity: 4
        }, {
            host: "FTP115",
            method: 2,
            site_id: 10,
            site_name: "玉环市第二人民医院",
            status: 0,
            alert_severity: 7
        }]
    }
}